<template>
  <section class="d-flex">
    <div class="survey-snapshot-section border">
      <div
        class="question"
        v-for="(question, index) in visibleQuestions"
        :key="question.question_text"
      >
        <div class="question-text">
          {{ question.question_text }}
          <b-icon-trash
            v-if="editable"
            role="button"
            class="float-right"
            @click="deleteQuestion(index)"
          />
        </div>
        <ul
          class="answer pl-0"
          style="list-style: none"
          v-for="(answer, answerIndex) in question.answers"
          :key="answerIndex"
        >
          <li class="d-flex align-items-center">
            <b-icon-record-circle-fill class="accent-color" />
            <span>{{ answer.text }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex align-items-center ml-1">
      <SectionControls :case-study-id="caseStudyId" :index="index" v-if="editable" />
    </div>
  </section>
</template>
<script>
import { useCaseStudyStore } from '@app/stores/CaseStudyStore'
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'

export default {
  name: 'SurveySnapshotSection',
  components: { SectionControls },
  mixins: [SectionMixin],
  props: {
    caseStudyId: { type: Number, required: true },
    section: { type: Object, required: true },
    accentColor: { type: String, required: true },
    index: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
  },
  computed: {
    visibleQuestions() {
      return this.section.questions.filter((q) => q.visible)
    },
  },
  methods: {
    deleteQuestion(index) {
      const updatedQuestions = this.visibleQuestions.slice()
      updatedQuestions[index].visible = false
      const updatedSection = { ...this.section, ...{ questions: updatedQuestions } }
      useCaseStudyStore().updateSection(this.caseStudyId, this.index, updatedSection)
    },
  },
}
</script>

<style lang="sass" scoped>
.survey-snapshot-section
  width: 100%
  padding: 16px
  border-radius: 16px
  background-color: #fafafb
  ul
    margin-bottom: 8px

.question-text
  font-weight: bolder
  font-size: 20px

.answer
  margin-top: 8px
  font-size: 16px
  color: #6c757d
  li
    span
      padding-left: 2px

.accent-color
  color: v-bind("accentColor")
</style>
